import Routes from 'Routes';
import axios from 'axios';
import { setupInterceptorsTo } from 'config/axios/interceptors';
import 'config/i18n';
import { LayoutProvider } from 'context/HamberProvider';
import cookie from 'helper/cookie';
import { Localestype } from 'models/types';
import { LightTheme } from 'providers/theme';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { selectLocale } from 'store/options/optionsSlice';
import { ThemeProvider } from 'styled-components';
import getTheme from 'theme';
import './app.css';
const AppWithTheme = () => {
  setupInterceptorsTo(axios);

  const theme = getTheme();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  let route = window.location.pathname.split('/');
  let brokenRoute = false;
  if (route[1] !== 'passenger') {
    brokenRoute = true;
    route.splice(1, 0, 'passenger');
  }
  if (!['fa', 'en'].includes(route[2])) {
    brokenRoute = true;
    route.splice(2, 0, 'fa');
  }
  if (brokenRoute) window.history.replaceState(null, '', route.join('/') + window.location.search);

  document.body.dir = i18n.dir();

  axios.defaults.headers.common['locale'] = route[2];
  axios.defaults.headers['authorization'] = `Bearer ${cookie.get('authorization')}`;

  useEffect(() => {
    dispatch(selectLocale(route[2] as Localestype));
  }, []);

  var sheet = document.createElement('style');
  sheet.type = 'text/css';
  sheet.innerHTML = `*{
    font-family:${i18n.dir() === 'rtl' ? 'Vazirmatn FD' : 'roboto'};
    line-height: ${i18n.dir() === 'rtl' ? 'normal' : '150%'};
  }`;
  document.body.appendChild(sheet);

  return (
    <ThemeProvider
      theme={{
        ...LightTheme,
        ...theme,
        direction: i18n.dir(),
      }}
    >
      <LayoutProvider>
        <div className="App">
          <Routes />
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={i18n.dir() === 'ltr' ? false : true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </LayoutProvider>
    </ThemeProvider>
  );
};

const App: React.FC = () => <AppWithTheme />;

export default App;
